var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchiveLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50001 8.33333H1.66667V3.33578C1.66667 2.87419 2.0461 2.5 2.49317 2.5H17.5068C17.9633 2.5 18.3333 2.8649 18.3333 3.33578V8.33333H17.5V16.6679C17.5 17.1275 17.1293 17.5 16.6722 17.5H3.32784C2.87064 17.5 2.50001 17.1271 2.50001 16.6679V8.33333ZM15.8333 8.33333H4.16667V15.8333H15.8333V8.33333ZM3.33334 4.16667V6.66667H16.6667V4.16667H3.33334ZM7.5 10H12.5V11.6667H7.5V10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveLine);
export default __webpack_public_path__ + "static/media/archive-line.3db40c80652a972965bfc005f0f6abe9.svg";
export { ForwardRef as ReactComponent };